/* eslint-disable */
import { Metrics, Colors, Fonts } from '../../Themes'
import { StyleSheet, Dimensions } from 'react-native'

const screenDimensions = Dimensions.get("window")
const screenWidth = screenDimensions.width
const isIPhoneSE = (screenWidth === 320.0)
const containerDimension = isIPhoneSE ? 64 : 94
const imageDimension = isIPhoneSE ? 54 : 84

export default StyleSheet.create({
    container: {
        backgroundColor: 'white',
        borderRadius: containerDimension / 2,
        height: containerDimension,
        width: containerDimension,
        justifyContent: 'center',
      },
    
      image: {
        alignSelf: 'center',
        borderRadius: imageDimension / 2,
        height: imageDimension,
        width: imageDimension,
        resizeMode: 'cover',
      },
    
      badgeButton: {
        position: 'absolute',
        right: 0,
        top: 0,
      }
  })


